var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96065 0.59625L11.9027 4.51324C12.0487 4.80824 12.3307 5.01226 12.6577 5.05926L17.1406 5.70721C17.9626 5.82621 18.2906 6.83423 17.6956 7.41223L14.4547 10.5572C14.2177 10.7872 14.1096 11.1182 14.1656 11.4432L14.9066 15.7473C15.0566 16.6203 14.1396 17.2862 13.3536 16.8752L9.46566 14.8403C9.17366 14.6873 8.82563 14.6873 8.53463 14.8403L4.64962 16.8732C3.86262 17.2852 2.94259 16.6182 3.09359 15.7432L3.83468 11.4432C3.89068 11.1182 3.78261 10.7872 3.54561 10.5572L0.304646 7.41223C-0.291354 6.83423 0.0365773 5.82621 0.859577 5.70721L5.34261 5.05926C5.66861 5.01226 5.95061 4.80824 6.09761 4.51324L8.03963 0.59625C8.43063 -0.19875 9.56665 -0.19875 9.96065 0.59625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2551515343c18b272536f9f1242d81d3.svg";
export { ForwardRef as ReactComponent };